<template>
  <footer
    class="section padding-top-bottom over-hide z-bigger background-dark-3 footer"
  >
    <div class="shadow-on-footer">
      Say Hello
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 text-center z-bigger py-5">
          <div class="footer-lines">
            <router-link to="/contact" tag="a"
              ><h4>Got a Project?</h4></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ScrollReveal from "scrollreveal";
export default {
  mounted() {
    ScrollReveal().reveal(".footer-lines", {
      duration: 1000,
      distance: "50px",
      mobile: false
    });
    ScrollReveal().reveal(".shadow-on-footer", {
      duration: 1000,
      distance: "50px",
      origin: "top",
      mobile: false
    });
  }
};
</script>

<style lang="scss" scoped>
.footer {
  a {
    position: relative;
    display: inline-block;
    text-decoration: none;

    &:after {
      position: absolute;
      content: "";
      bottom: 2px;
      left: 0;
      width: 100%;
      height: 0px;
      opacity: 1;
      margin-top: 3px;
      background-color: $primary;
      z-index: -1;
      transition: all 200ms linear;
    }

    &:hover:after {
      height: 20px;
      opacity: 1;
    }
  }
}

.footer-lines {
  position: relative;

  &:after,
  &:before {
    position: absolute;
    width: 2px;
    height: 25px;
    content: "";
    z-index: -1;
    left: 50%;
    margin-left: -1px;
    background-color: #4b4d64;
  }
}

.footer-lines:after {
  top: -50px;
}

.footer-lines:before {
  bottom: -50px;
}

.shadow-on-footer {
  position: absolute;
  bottom: 0;
  left: -50%;
  width: 200%;
  text-align: center;
  font-family: "Muli", sans-serif;
  font-size: 14vw;
  line-height: 1;
  color: rgba(200, 200, 200, 0.1);
  background: linear-gradient(rgba(75, 77, 100, 0.25), rgba(75, 77, 100, 0));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  z-index: 1;
}
</style>
